import { newChargingServiceCloud } from "@/services/orderTestRequest";

export function getStripeKey(params = null) {
  let payload = {
    url: params ? `/transaction/stripeKey/${params}` : "/transaction/stripeKey",
    method: "get"
  };
  return newChargingServiceCloud(payload);
}

export function updateCreditCard(paymentMethodId, { expiry_date }) {
  return newChargingServiceCloud({
    url: `/paymentMethod/${paymentMethodId}`,
    method: "put",
    data: { expiry_date },
  });
}

export function getCustomerTokenApi(params) {
  let { accountId, accountType, clinicId, tokenPlatform } = params;
  let url = `/customerInfo/customerToken?account_id=${accountId}&account_type=${accountType}&token_platform=${tokenPlatform}`;
  if (accountType === "customer" && clinicId) {
    url += `&clinic_id=${clinicId}`;
  }
  let payload = {
    url,
    method: "get"
  };
  return newChargingServiceCloud(payload);
}

export function createPaymentIntent(data) {
  let payload = {
    url: "/transaction/createPayment",
    method: "post",
    data
  }
  return newChargingServiceCloud(payload);
}

export function chargeApi(data) {
  let payload = {
    url: "/transaction/pay",
    method: "post",
    data
  }
  return newChargingServiceCloud(payload);
}

export function savePaymentApi(data) {
  let payload = {
    url: "/paymentMethod",
    method: "post",
    data
  };
  return newChargingServiceCloud(payload);
}

export function getSavedPaymentsApi(params) {
  let { customerId, clinicId, methodType } = params;
  let url = `/paymentMethod/allSharedPaymentMethods?customer_id=${customerId}&clinic_id=${clinicId}`;
  if (methodType) {
    url += `&method_type=${methodType}`;
  }
  let payload = {
    url,
    method: "get"
  };
  return newChargingServiceCloud(payload);
}

export function deleteSavedPaymentApi(params) {
  let { paymentMethodId } = params;
  let payload = {
    url: `/paymentMethod/${paymentMethodId}`,
    method: "delete"
  };
  return newChargingServiceCloud(payload);
}

export function payOrdersApi(data) {
  let payload = {
    url: "/transaction/payOrders",
    method: "post",
    data
  };
  return newChargingServiceCloud(payload);
}

export function transactionInfoV2Api(data) {
  let payload = {
    url: "/transaction/transactionInfoV2",
    method: "post",
    data
  };
  return newChargingServiceCloud(payload);
}

export function getStaxKeyApi() {
  return newChargingServiceCloud({
    url: "/transaction/staxKey",
    method: "get",
  });
}
// PUT /paymentMethod/priority — reorders an account's saved payment methods
// (Charging Module API #6). Body:
//   account_id      integer   required
//   account_type    string    required - "customer" | "patient" | "clinic" | "platform"
//   clinic_id       integer   required when account_type is "customer" and the
//                             JWT clinic_id is not the customer's clinic
//   payment_method_ids [integer]  required, non-empty. Payment method ids (not
//                             stax/stripe tokens) in the desired order,
//                             first = highest priority. Every id must belong to
//                             the account and not be deleted.
// Responds with the account's payment methods in the new order.
export function updatePaymentMethodPriorityApi(data) {
  let payload = {
    url: "/paymentMethod/priority",
    method: "put",
    data
  };
  return newChargingServiceCloud(payload);
}

/**
 * POST /transaction/topup — wallet top-up. Charges the payment method and
 * creates a `deposit` credit; no order involved.
 *
 * Body: account_type ("customer"|"clinic"), account_id (must match the JWT),
 * clinic_id (customer top-ups only), amount (>= 0.50, usd only),
 * type ("card"|"ach"), token_platform ("stripe"|"stripe_zb"|"stax"),
 * payment_token, and optionally customer_token / record_id / notes.
 *
 * Responds with { record_id, credit_id, credit_status, status, client_secret }.
 * credit_status 1 = valid, 2 = pending (ACH, or a card awaiting client-side
 * confirmation) and excluded from the available balance until a webhook settles
 * it. A `client_secret` means the frontend still has to confirm the intent.
 *
 * Retry-safe on the same record_id: a repeat returns the existing top-up rather
 * than creating a second credit, which is how a 502 is recovered.
 */
export function topUpApi(data) {
  return newChargingServiceCloud({
    url: "/transaction/topup",
    method: "post",
    data
  });
}
